import React from 'react';
import moment from 'moment';

import { Description } from './Description';

import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';

import { DATE_TIME_FORMAT } from '../utilities/constants';

import styles from '../styles/componentStyle/description/FetchCcusDescription.scss';

/**
 * CCUS情報取得に関する捕捉文
 * @props {string}description:捕捉文
 * @props {boolean}disabledCcusConnectionButton:CCUS連携ボタンの状態
 * @props {string}linkedToCcusDate:CCUS連携時刻
 * @props {function}onClick:CCUS連携ボタン押下時の処理
 */
export class FetchCcusDescription extends React.Component {
  constructor(props) {
    super(props);
  }

  // 画面表示
  render() {
    return (
      <div className={styles.description}>
        <Description>
          <div className='fetch-ccus-description-button__section'>
            <button
              className={
                this.props.disabledCcusConnectionButton
                  ? data.button.updateCcusInfo.disabledClassName
                  : data.button.updateCcusInfo.className
              }
              disabled={this.props.disabledCcusConnectionButton}
              onClick={this.props.onClick}
            >
              {data.button.updateCcusInfo.label}
            </button>
            {isNullOrUndefinedOrEmptyStr(this.props.linkedToCcusDate) ===
              false && (
              <span className='linked_to_ccus_date'>
                {data.fetchDate.description}
                {moment(
                  new Date(this.props.linkedToCcusDate).toISOString()
                ).format(DATE_TIME_FORMAT.slashDateTimeFormat)}
              </span>
            )}
          </div>
          <div className='fetch-ccus-description-message__section'>
            <p className='ccus_description_message'>{this.props.description}</p>
          </div>
        </Description>
      </div>
    );
  }
}

// 定数
const data = {
  button: {
    updateCcusInfo: {
      label: 'CCUSから情報を取得',
      className: 'btn',
      disabledClassName: 'btn-disable',
    },
  },
  fetchDate: {
    description: 'CCUS入力情報取得日時：',
  },
};



// WEBPACK FOOTER //
// ./src/components/FetchCcusDescription.jsx